import { FC } from "react";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "src/components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { Link } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
import appConfig from "src/app.config";

type DiscountsCardProps = Partial<any> & {
  loading?: boolean;
  onClick?: () => void;
  code: string;
};

const GiftCard: FC<DiscountsCardProps> = ({ imageUrl, name, loading, code }) => {
  if (loading) {
    return (
      <div className="relative rounded-lg bg-background-default px-6 py-4 shadow-md outline outline-border-default overflow-hidden">
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex h-60 w-60 animate-pulse items-center justify-center overflow-hidden rounded-lg bg-background-subtle">
            <svg className="h-10 w-10 text-icon-subtle" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
          <div className="h-5 w-2/3 animate-pulse rounded-sm bg-background-subtle" />
          <div className="flex w-full flex-col gap-1.5">
            <div className="h-3 w-24 animate-pulse rounded-sm bg-background-subtle" />
            <div className="h-5 w-32 animate-pulse rounded-sm bg-background-subtle" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Link
      className="relative font-inter group overflow-hidden rounded-lg bg-background-default p-2 px-4 shadow-md outline outline-border-default transition-shadow hover:shadow-sm"
      to={`${code}`}
      onClick={() => track("Card Selected", { code, name })}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex h-55 w-55 items-center justify-center overflow-hidden rounded-lg p-4">
          <ImageWithEmptyFallback
            src={`${appConfig.GCP_IMAGES_BUCKET}${imageUrl}`}
            alt={name}
            className="h-full! w-full! object-contain transition-transform duration-300 group-hover:scale-105 rounded-md!"
          />
        </div>
      </div>
    </Link>
  );
};

export default GiftCard;
